<template>
  <div class="question">
    <div class="img" @touchend="slide">
      <img :src="'//cdn.original-fun.com/gugong/' + arr[idx] + '.png'" />
    </div>
    <div class="button" @click="finish">
      逛完了
    </div>
    <div class="img-slide" @touchend="slide">
      左右滑动试试看哦
    </div>
  </div>
</template>

<script>
//script
import Tools from '../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../scripts/Global';

//组件
import HeadTip from './headTip';

export default {
  props: ['data'],
  data() {
    return {
      idx: 0,
      arr: ['tuan团扇', '笔记本', '立体便签', '渔夫帽'],
    };
  },
  components: { HeadTip },
  created() {},
  computed: {},
  methods: {
    finish() {
      this.$emit('finish', true);
    },
    slide() {
      let _idx = this.idx + 1;
      this.idx = _idx % this.arr.length;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.question {
  background-image: url(//cdn.original-fun.com/gugong/答题弹框.png);
  background-position: 0 90%;
  width: 7.5rem;
  height: 9rem;
  margin: 0 auto;
  background-repeat: no-repeat;
  position: relative;
  bottom: 0;
  background-size: contain;
  top: 50%;
  margin-top: -5rem;
  font-size: 12px;
  position: absolute;
  .button {
    background-image: url(//cdn.original-fun.com/gugong/答题未选中按钮.png);
    position: absolute;
    width: 4rem;
    height: 1rem;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    color: #fff;
    line-height: 1rem;
    margin-left: -2rem;
    margin-top: 0.1rem;
    left: 50%;
  }

  .img {
    width: 4rem;
    margin: 2.8rem auto 0 auto;
    img {
      width: 100%;
    }
  }

  &.man {
    .text {
      width: 3.2rem;
      padding: 0.1rem 1rem 0.1rem 0.2rem;
    }
  }

  .text {
    width: 4rem;
    background: #ffffff54;
    margin: 2.2rem auto 0 auto;
    padding: 0.1rem 0.2rem 0.1rem 0.2rem;
    text-align: left;
    color: #6c5141;
    font-weight: bold;
  }

  .img-slide {
    background-image: url(//cdn.original-fun.com/gugong/左右滑动提示箭头.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    height: 0.6rem;
    width: 4rem;
    position: absolute;
    left: 50%;
    margin-left: -2rem;
    line-height: 0.6rem;
    color: #8f663d;
    bottom: 1rem;
  }
}
</style>
